import type { DemographicsResponse } from '../types/member-demographics.js';
import { request } from './api.js';

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Marketing
 * @graph-business 会員デモグラフィクス分析 API クライアント。サブスク会員の多面的分析データを取得する。
 * @graph-connects /member-demographics [calls] 会員デモグラフィクス分析
 */
export const memberDemographicsApi = {
  getDemographics: (): Promise<DemographicsResponse> =>
    request<DemographicsResponse>('/member-demographics'),
};
